import React, { useContext, useEffect } from 'react';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import themeContext from '../../../../context/theme/themeContext';
import Button from '../../../../components/Button';
import CustomSlider from '../../../../components/CustomSlider';
import { TabsContext } from '../../../../components/Tabs';
import CreateSpoolDetail from './CreateSpoolDetail';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../../../config/constants';

const feeRange = {
    min: 0,
    max: 20,
};

const CreateSpool: React.FC = () => {
    const { spoolName, spoolFee, setStepCompletedStatus, setSpoolName, setSpoolFee } =
        useContext(CreateASpoolContext);

    const { chainId } = useWeb3React();

    const { setDisabled } = useContext(TabsContext);

    const { theme } = useContext(themeContext);

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setSpoolName(value);
    };

    const handleFeeChange = (fee: number) => {
        setSpoolFee(fee);
    };

    const decrement = () => {
        if (spoolFee <= feeRange.min) return;

        setSpoolFee(spoolFee - 1);
    };

    const increment = () => {
        if (spoolFee >= feeRange.max) return;

        setSpoolFee(spoolFee + 1);
    };

    const handleBeforeChange = () => setDisabled(true);

    const handleAfterChange = () => setDisabled(false);

    useEffect(() => {
        if (!spoolName) {
            setStepCompletedStatus(5, false);
            return;
        }
        setStepCompletedStatus(5, true);
    }, [spoolName, spoolFee, setStepCompletedStatus]);

    return (
        <div className={`create-spool ${theme}`}>
            <span>Name your Spool and ensure that your selections are correct.</span>
            <div className='input-container'>
                <div className='spool-name'>
                    <div className='title'>Name of Spool</div>
                    <span>
                        Please use standard letters and numbers: A-Z 0-9 (32 Characters
                        Max)
                    </span>
                    <input type='text' value={spoolName} onChange={handleNameChange} />
                </div>
                <div className='spool-fee'>
                    <div className='title'>Set your Performance Fee (Max 20%):</div>
                    <div className='fee-value-container'>
                        <div className='slider-container'>
                            <Button onClick={decrement}>-</Button>
                            <CustomSlider
                                range={feeRange}
                                rangeSuffix='%'
                                value={spoolFee}
                                onChange={handleFeeChange}
                                onBeforeChange={handleBeforeChange}
                                onAfterChange={handleAfterChange}
                            />
                            <Button onClick={increment}>+</Button>
                        </div>
                        <div className='value-container'>
                            <div className='title'>Performance Fee</div>
                            <div className='fee-value'>
                                <Button onClick={decrement}>-</Button>
                                <span>{spoolFee}%</span>
                                <Button onClick={increment}>+</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CreateSpoolDetail />
            <p className='disclaimer'>
                A Smart Vault always auto-compounds APY and with TVR &gt;{' '}
                {chainId === SupportedChains.MAINNET ? '$100k' : '$1k'} also reallocates
                funds when risk scores change.
            </p>
        </div>
    );
};

export default CreateSpool;
